<template>
  <div :ref="'rm_' + index" class="rm">
    <div v-if="selected == index" class="rm-form row">
      
      <!-- SPECIAL Montage SIGNUP METHOD -->
      <div v-if="registration_method.registration_method_id == 3">
        <div class="row mb-15" v-if="useEmail">
          <input
            v-model="form.first_name"
            class="input-text"
            placeholder="First Name"
            type="text"
          />
        </div>
        <div class="row mb-15">
          <input
            v-model="form.last_name"
            class="input-text"
            placeholder="Last Name"
            type="text"
          />
        </div>
        <div class="row mb-15" v-if="useEmail">
          <input
            v-model="form.email_address"
            class="input-text"
            placeholder="Email"
            type="text"
          />
        </div>
        <div class="row mb-15" v-if="!useEmail">
          <input
            v-model="form.room_number"
            class="input-text"
            placeholder="Room Number"
            type="number"
          />
        </div>
        <div v-if="useEmail" class="row mb-15 checkbox-row">
          <label for="checkbox-consent">
            <input
              id="checkbox-consent"
              v-model="form.signUp"
              type="checkbox"
            />
            <span>I would like to be the first to know about our upcoming specials, vacation offers, and exciting new developments from Montage Hotels & Resorts.</span>
          </label>
          <!-- <label for="checkbox-marketing">
            <input
              id="checkbox-marketing"
              v-model="form.residentOffers"
              type="checkbox"
            />
            <span>I would like to receive residential related updates and offers from our buinsess partners.</span>
          </label> -->
        </div>
      </div>
      <!-- END SPECIAL SIGN UP METHOD -->
      
      <div>
        <button
          class="btn btnSpecial btnAlt"
          type="button"
          @click="toggleEmailRoom()"
        >
          <span v-if="useEmail">Alternatively enter your name and room number</span>
          <span v-if="!useEmail">Alternatively enter your name and email</span>
        </button>
      </div>
      <div>
        <button
          class="btn btnSpecial"
          type="button"
          @click="emitRegistrationMethodData()"
        >
          Continue
        </button>
      </div>
      <p
        class="bottom-link"
      >
        By clicking continue you agree to the
        <span class="text-link" @click="selectTermsOfService(index)"
          >Terms and Conditions</span
        >
      </p>
      <div
        v-if="selected_tos == index"
        class="terms-of-service text-left pt-20"
      >
        <div v-html="registration_method.terms_of_service"></div>
        <div class="mt-30 text-center">
          <button class="btn-close" @click="selectTermsOfService(null)">
            CLOSE
          </button>
        </div>
      </div>
      <p
        class="bottom-link"
      >
        To learn more about how we use your personal information, visit us online at
        <a class="text-link" href="#">montageinternational.com/privacy-policy</a>
      </p>
    </div>
  </div>
  <!-- rm -->
</template>
<script>
import {HTTP} from '@/utilities/http'

export default {
  name: "registration_method",
  props: [
    "index",
    "selected",
    "selected_tos",
    "color_background_button",
    "color_text_button",
    "registration_method",
    "hotelCode"
  ],
  data() {
    return {
      useEmail: true,
      access_code: null,
      access_code_valid: true,
      access_code_error_text: "Required",
      selected_error: false,
      form: {
        first_name: "",
        last_name: "",
        room_number: "",
        email_address: "",
        signUp: 1
      },
    };
  },
  mounted() {
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription: function (rm) {
      if (rm.type != "rateplan") return null;
      let description = "";
      if (parseInt(rm.price) === 0) {
        description += "Connect";
      } else {
        description += "$" + rm.price;
      }

      description += " for ";

      if (rm.duration >= 1440) {
        if (rm.duration % 1440 > 0) {
          description += " more than ";
        }
        var whole_days = Math.floor(rm.duration / 1440);
        description += whole_days + " day";
        if (whole_days > 1) {
          description += "s";
        }
      } else if (rm.duration >= 60) {
        if (rm.duration % 60 > 0) {
          description += " more than ";
        }
        var whole_hours = Math.floor(rm.duration / 60);
        description += whole_hours + " hour";
        if (whole_hours > 1) {
          description += "s";
        }
      } else {
        description += rm.duration + " minute";
        if (rm.duration > 1) {
          description += "s";
        }
      }

      description += " with ";
      if (rm.additional_devices > 0) {
        description += "up to " + rm.additional_devices + " devices";
      } else {
        description += "1 device";
      }
      if (rm.speed_upload && rm.speed_download) {
        description +=
          " (" + rm.speed_upload + " Up / " + rm.speed_download + " Down)";
      }
      return description;
    },
    toggleEmailRoom: function() {
      this.useEmail = !this.useEmail
    },
    // Send selected Registration Method back to parent
    selectRegistrationMethod: function (index) {
      this.$emit("changeSelected", index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService: function (index) {
      this.$emit("changeSelectedTOS", index);
    },
    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData: function () {
      // If no access code set, show required text
      if (this.registration_method.type == "accesscode" && !this.access_code) {
        this.access_code_valid = false;
        return;
      }
      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: this.registration_method.id,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
        signUp: this.form.signUp
      };

      // if the form for email is filled out we send email info and reg method 3
      if(this.form.email_address !== '') {
        emitted.registration_method_id = 3;
        emitted.email_address = this.form.email_address;
        emitted.last_name = this.form.last_name;
        emitted.first_name = this.form.first_name;

        if(emitted.signUp) {
          let fields = {
            last_name: emitted.last_name,
            first_name: emitted.first_name,
            email: emitted.email_address,
            hotelCode: this.hotelCode
          }

          HTTP.post('montage-marketing', fields).then(function (response) {
            this.$emit("emitRegistrationMethodData", emitted);
          }.bind(this))
        } else {
          this.$emit("emitRegistrationMethodData", emitted);
        }
      } else {
        // in this case it will be ln & rn so we change method id to 2 - ln/rn
        emitted.registration_method_id = 2;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;

        this.$emit("emitRegistrationMethodData", emitted);
      }     
    },
  },
};
</script>
<style>

#logo {
  padding: 3% !important;
}

.btnAlt {
  background: #767575ab !important;
}

.btnSpecial {
  text-transform: uppercase; 
  font-size: 12px !important;
  height: 65px;
  margin-bottom: 10px;
  -webkit-filter: brightness(1);
   filter: brightness(1);
}

.btnSpecial:hover {
  -webkit-filter: brightness(3);
   filter: brightness(3);
}

input {
  color: white;
}

#rms {max-width: 550px;}

#logo img {
  max-width: 275px;
}

.rm a,
.rm span.text-link {
  color: #d184c2;
  text-decoration: underline;
  cursor: pointer;
}

.rm .help-text {
  color: #000000;
  padding: 5px 0;
  font-size: 14px;
  font-style: italic;
  text-align: center;
  display: block;
}

.rm .error-text {
  text-transform: uppercase;
  position: absolute;
  line-height: 1;
  right: 12px;
  top: 12px;
  padding: 8px 8px 7px 8px;
  background: red;
  color: #ffffff;
  border-radius: 3px;
  text-align: left;
  font-weight: bold;
  font-size: 12px;
}

.rm:last-child {
  border: none;
}

.rm .rm-header {
  border-top-width: 1px;
  border-top-style: solid;
  cursor: pointer;
}

.rm .rm-form {
  background: none;
  width: 75%;
  margin: auto;
  border: none;
}


.rm .input-text {
  border-radius: 10px;
  border: none;
  border-bottom: 1px solid #cccccc;
  overflow: visible;
  width: 100%;
  padding: 15px;
  font-size: 16px;
  text-align: left;
}

.rm .btn {
  background: #00000070;
  border: 2px solid rgb(255 255 255 / 30%);
  color: white;
  border-radius: 10px;
}

.rm .btn {
  width: 100%;
  padding: 20px;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
}

.rm .btn.rounded {
  border-radius: 6px;
}

.rm label {
  display: inline-block;
  padding: 0px;
  width: 100%;
  font-size: 18px;
  margin: 10px 0;
}

.rm label span {
  font-size: 14px;
  font-weight: bold;
  padding-left: 6px;
  float: left;
  width: 88%;
}

.rm .input-radio {
  display: inline-block;
  padding: 10px;
}

@media screen and (max-device-width: 800px) {
  .rm .rm-form {
    width: 75%;
    margin: 0 auto;
  }
}

.checkbox-row {
  text-align: left;
}

.checkbox-row input {
    margin-right: 10px;
    border-radius: 5px;
    float: left;
    width: 5%;
}

.input-text {
  text-align: center;
}

.top-btn {
  margin-top: 1rem;
}

.bottom-link, .bottom-link a, .bottom-link a:visited, .rm span.text-link {
  color: white;
  font-size: 12px;
}
</style>
